// extracted by mini-css-extract-plugin
export default {"table":"DisplayLikeTable_table__TsCmX"};